/**
 * ExportButton Component
 *
 * Button for exporting filtered task list to CSV.
 */

import { Download } from 'lucide-react';
import { ToolbarButton } from './ToolbarButton';
import { exportTasksToCSV } from '@/utils/csvExport';
import type { Task } from '@/types';

export interface ExportButtonProps {
  tasks: Task[];
}

export function ExportButton({ tasks }: ExportButtonProps) {
  const handleExport = () => {
    if (tasks.length > 0) {
      exportTasksToCSV(tasks);
    }
  };

  return (
    <ToolbarButton
      icon={<Download className="w-3 h-3" />}
      label="Esporta CSV"
      onClick={handleExport}
    />
  );
}
